var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrice4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af9b5b;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cout4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.87,27.29A11.06,11.06,0,0,1,36,17a10.9,10.9,0,0,0-4-.75,11.07,11.07,0,1,0,4,21.39A11.06,11.06,0,0,1,28.87,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.87,27.29a11,11,0,0,1,3.44-8l-.31,0a8,8,0,0,0,0,16h.31A11,11,0,0,1,28.87,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9,27.29A11.06,11.06,0,0,1,28,17a10.9,10.9,0,0,0-4-.75,11.07,11.07,0,1,0,4,21.39A11.06,11.06,0,0,1,20.9,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9,27.29a11,11,0,0,1,3.44-8l-.31,0a8,8,0,0,0,0,16h.31A11,11,0,0,1,20.9,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.94,27.29A11.06,11.06,0,0,1,20,17a10.9,10.9,0,0,0-4-.75,11.07,11.07,0,1,0,4,21.39A11.06,11.06,0,0,1,12.94,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.94,27.29a11,11,0,0,1,3.43-8l-.31,0a8,8,0,0,0,0,16h.31A11,11,0,0,1,12.94,27.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.94,
    cy: 27.29,
    r: 11.06,
    transform: "translate(4.25 59.93) rotate(-76.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.94,
    cy: 27.29,
    r: 8.02,
    transform: "translate(4.23 59.92) rotate(-76.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice4);
export default __webpack_public_path__ + "static/media/icon_price_4.554fba1fddf7650d1c4a60fd8347301e.svg";
export { ForwardRef as ReactComponent };